import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/constants';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 px-4 max-w-3xl mx-auto" data-id="element-151">
      <div className="text-center mb-12" data-id="element-152">
        <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight" data-id="element-153">
          Preguntas <span className="text-primary" data-id="element-154">Frecuentes</span>
        </h2>
      </div>

      <div className="space-y-4" data-id="element-155">
        {faqs.map((f, i) => {
        const isOpen = openIndex === i;
        return <div key={i} className={`rounded-2xl border transition-colors duration-200 ${isOpen ? 'bg-surface border-primary/50' : 'bg-black border-zinc-800 hover:border-zinc-600'}`} data-id="element-156">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between gap-4 focus:outline-none" onClick={() => setOpenIndex(isOpen ? null : i)} data-id="element-157">
                <span className="font-bold text-white text-lg" data-id="element-158">{f.q}</span>
                <ChevronDown className={`w-5 h-5 text-primary shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-159" />
              </button>

              <AnimatePresence data-id="element-160">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-161">
                    <div className="px-6 pb-6 text-zinc-400 text-base leading-relaxed" data-id="element-162">
                      {f.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </section>;
}